import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterCargaPasstModel } from 'src/app/models/interfaces/passt/IFilterCargaPasstModel';
import { CargaPasstModel } from 'src/app/models/passt/CargaPasstModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CargaPasstService {
  private configUrl = [environment.apiGatewayUrl, 'cargas-passt'].join('/');
  constructor(private http: HttpClient,
  private datepipe: DatePipe) { }

  getList(
    model: IFilterCargaPasstModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<CargaPasstModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }
    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }
    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }
    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get<SearchResultModel<CargaPasstModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  submit(model: CargaPasstModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  upload(formData: FormData, anio: string){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${anio}/upload`, formData, {reportProgress: true, observe: 'events'});
  }
}
